<template>
  <video
    ref="videoRef"
    class="lazy-video"
    muted
    playsinline
    autoplay
    loop
    preload="none"
    :poster="poster"
    @abort="handleVideoError"
    @suspend="handleVideoError"
    @error.capture="handleVideoError"
  />
</template>

<script setup>
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  poster: {
    type: String,
    default: undefined,
  },
});

const videoRef = ref(null);

onMounted(() => {
  if (!videoRef.value) return;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const source = document.createElement('source');
          source.src = props.src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video?.load();

          // Пытаемся воспроизвести после загрузки
          video?.play().catch((err) => {
            console.warn('Autoplay prevented:', err);
          });

          observer.unobserve(video);
        }
      });
    },
    {
      rootMargin: '0px 0px 150px 0px',
    },
  );

  observer.observe(videoRef.value);
});

const { setupVideoAutoplay, onVideoError } = useVideoAutoplay();

onMounted(async () => {
  await setupVideoAutoplay(videoRef);
});

const handleVideoError = onVideoError(videoRef);
</script>

<style scoped>
.lazy-video {
  width: 100%;
  display: block;
}
</style>
